import { Link, StaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image"
import React from 'react'


export default function Header({ data }) {

  

    return (
      <StaticQuery
        query={graphql`
          query HeadingQuery {
            allFile(filter: { extension: { regex: "/(jpg|jpeg|png|gif)/" } }) {
              edges {
                node {
                  relativePath
                  childImageSharp {
                    gatsbyImageData(width: 256)
                  }
                }
              }
            },
            site {
              siteMetadata {
                author {
                  name
                  summary
                  social {
                    twitter
                    linkedin
                    github
                    facebook
                    steam
                    twitch
                    youtube
                    itch
                    tiktok
                  }
                }
                features {
                  name
                  description
                  img
                  link
                  alt
                }
                description
              }
            }
          }
        `}
        render={ data => (
            <header className="navbar navbar-expand-lg navbar-light bg-light fixed-top" role="navigation">
                <div className="container-fluid container-sm flex-wrap">
                    <Link className="navbar-brand" to="/" title="loudoweb.fr"><StaticImage src="../images/profile-pic.png" width={110} height={110} alt="loudoweb's logo"/></Link>
                    <button className="navbar-toggler ms-auto" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse" aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
                      <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarCollapse">
                      <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                          <li className="nav-item">
                          <Link  className="nav-link" to="/resume" title="Mon CV"><img src="/cv.png" alt="Curriculum Vitae"/><span className="d-inline-block ms-2 d-lg-none">CV</span></Link>
                          </li>
                          <li className="nav-item">
                          <Link  className="nav-link" to="/references" title="Mes références"><img src="/ref.png" alt="Références"/><span className="d-inline-block ms-2 d-lg-none">Références</span></Link>
                          </li>
                          <li className="nav-item">
                          <Link className="nav-link" to="/article/page/" title="Tous les articles"><img src="/archive.png" alt="Archives"/><span className="d-inline-block ms-2 d-lg-none">Archives</span></Link>
                          </li>
                      </ul>
                      <ul className="navbar-nav ml-auto">
                          
                          {data.site.siteMetadata.author.social.github && 
                          <li className="nav-item">
                          <a className="nav-link" href={`https://github.com/${data.site.siteMetadata.author.social.twitter}`} title={`${data.site.siteMetadata.author.name} sur Github`}><img src="/social/github.png" alt={`${data.site.siteMetadata.author.name} sur Github`}/><span className="d-inline-block ms-2 d-lg-none">Github</span></a>
                          </li>
                          }
                          {data.site.siteMetadata.author.social.twitter && 
                          <li className="nav-item">
                          <a className="nav-link" href={`https://www.twitter.com/${data.site.siteMetadata.author.social.twitter}`} title={`${data.site.siteMetadata.author.name} sur Twitter`}><img src="/social/twitter.png" alt={`${data.site.siteMetadata.author.name} sur Twitter`}/><span className="d-inline-block ms-2 d-lg-none">Twitter</span></a>
                          </li>
                          }
                          {data.site.siteMetadata.author.social.facebook && 
                          <li className="nav-item">
                          <a className="nav-link" href={`https://www.facebook.com/public/${data.site.siteMetadata.author.social.facebook}`}  title={`${data.site.siteMetadata.author.name} sur Facebook`}><img src="/social/facebook.png" alt={`${data.site.siteMetadata.author.name} sur Facebook`}/><span className="d-inline-block ms-2 d-lg-none">Facebook</span></a>
                          </li>
                          }
                          {data.site.siteMetadata.author.social.tiktok && 
                          <li className="nav-item">
                          <a className="nav-link" href={`https://www.tiktok.com/@${data.site.siteMetadata.author.social.tiktok}`}  title={`${data.site.siteMetadata.author.name} sur Tiktok`}><img src="/social/tiktok.png" alt={`${data.site.siteMetadata.author.name} sur Tiktok`}/><span className="d-inline-block ms-2 d-lg-none">Tiktok</span></a>
                          </li>
                          }
                          {data.site.siteMetadata.author.social.linkedin && 
                          <li className="nav-item">
                          <a className="nav-link" href={`https://www.linkedin.com/in/${data.site.siteMetadata.author.social.linkedin}`} title={`${data.site.siteMetadata.author.name} sur Linkedin`}><img src="/social/linkedin.png" alt={`${data.site.siteMetadata.author.name} sur Linkedin`}/><span className="d-inline-block ms-2 d-lg-none">Linkedin</span></a>
                          </li>
                          }
                          {data.site.siteMetadata.author.social.youtube && 
                          <li className="nav-item">
                          <a className="nav-link" href={`https://www.youtube.com/channel/${data.site.siteMetadata.author.social.youtube}`} title={`${data.site.siteMetadata.author.name} sur Youtube`}><img src="/social/youtube.png" alt={`${data.site.siteMetadata.author.name} sur Youtube`}/><span className="d-inline-block ms-2 d-lg-none">Youtube</span></a>
                          </li>
                          }
                          {data.site.siteMetadata.author.social.itch && 
                          <li className="nav-item">
                          <a className="nav-link" href={`http://${data.site.siteMetadata.author.social.itch}.itch.io`}  title={`${data.site.siteMetadata.author.name} sur Itch`}><img src="/social/itch.png" alt={`${data.site.siteMetadata.author.name} sur Itch`}/><span className="d-inline-block ms-2 d-lg-none">Itch</span></a>
                          </li>
                          }
                          {data.site.siteMetadata.author.social.twitch && 
                          <li className="nav-item">
                          <a className="nav-link" href={`https://www.twitch.tv/${data.site.siteMetadata.author.social.twitch}`}  title={`${data.site.siteMetadata.author.name} sur Twitch`}><img src="/social/twitch.png" alt={`${data.site.siteMetadata.author.name} sur Twitch`}/><span className="d-inline-block ms-2 d-lg-none">Twitch</span></a>
                          </li>
                          }
                          {data.site.siteMetadata.author.social.steam && 
                          <li className="nav-item">
                          <a className="nav-link" href={`http://steamcommunity.com/profiles/${data.site.siteMetadata.author.social.steam}`}  title={`${data.site.siteMetadata.author.name} sur Steam`}><img src="/social/steam.png" alt={`${data.site.siteMetadata.author.name} sur Steam`}/><span className="d-inline-block ms-2 d-lg-none">Steam</span></a>
                          </li>
                          }
                      </ul>
                    </div>
                    <div className="col-12 job">{data.site.siteMetadata.author.summary}</div>
                </div>
            </header>

        )}
    />
    )
}
